function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserEye = function SvgUserEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.56 5.56c0 1.96-1.59 3.56-3.56 3.56S6.44 7.53 6.44 5.56 8.03 2 10 2s3.56 1.59 3.56 3.56Zm-4.65 12.3s.08.09.13.14H4.23c-1.42 0-2.22-.44-2.22-1.78 0-3.56 4-6.22 8-6.22 1.17 0 2.35.23 3.42.64-1.78.33-3.37 1.22-4.51 2.49a3.535 3.535 0 0 0 0 4.73Zm1.44-3.46c1.1-1.32 2.78-2.15 4.65-2.15s3.56.83 4.65 2.15c.46.56.46 1.4 0 1.96-1.1 1.32-2.78 2.15-4.65 2.15s-3.56-.83-4.65-2.15c-.46-.56-.46-1.4 0-1.96Zm.77.76c.5-.61 1.17-1.09 1.94-1.4-.35.44-.57 1-.57 1.62s.21 1.18.57 1.62c-.77-.31-1.44-.8-1.94-1.4-.1-.12-.1-.31 0-.43Zm7.76.43c-.5.61-1.17 1.09-1.94 1.4.35-.44.57-1 .57-1.62s-.21-1.18-.57-1.62c.77.31 1.44.8 1.94 1.4.1.12.1.31 0 .43Z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
};
export default SvgUserEye;